import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Header1 from '../public';

const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;

class HccCalIntro extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div>
              <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{ background: '#fff' }}>
              <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['5']}
                    defaultOpenKeys={['sub4']}
                    style={{ height: '100%' }}
                  >
                     <SubMenu key="sub3" title={<span><Icon type="user" />Lipiodol</span>}>
                      <Menu.Item key="1"><Link to="/hcc-ld-introduction">Introduction</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/hcc-ld-evaluation">Evaluation</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub4" title={<span><Icon type="user" />Prediction</span>}>
                      <Menu.Item key="5"><Link to="/hcc-cal-introduction">Introduction</Link></Menu.Item>
                      <Menu.Item key="6"><Link to="/hcc-cal-calculation">Calculation</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                <div>
                            <Content style={{ marginLeft: 50, background: '#dcefef' }}>
                                <div style={{ marginLeft: 100, paddingTop:30, width: 600, height: 800, background: '#dcefef' }}>
                                <txt style={{fontSize:20,marginTop:50,}}>
                                <txt style={{fontSize:22,fontWeight:'bold'}}>Welcome to visit the module of TACE efficacy prediction for patients with hepatocellular carcinoma.</txt> This module is designed to provide clinicians engaged in TACE treatment of hepatocellular carcinoma with a tool that enables a scientific and effective assessment of the clinical efficacy of the first TACE.
                                <br/><br/>The proposed method is derived from the data of more than 600 patients with hepatocellular carcinoma who were first treated with TACE in northern China. Statistical analysis of more than ten pre-treatment clinical indicators of enrolled patients, including age, gender, Child-Pugh grading, preoperative AFP, primary tumor size, metastasis, Karnofsky score, grade of BCLC, tumor capsule, and prognostic signatures constructed by medical image features, indicated that the <txt style={{fontSize:22,fontWeight:'bold'}}>primary tumor size, metastasis, and tumor capsule</txt> are the three most important factors on time to progression in patients with hepatocellular carcinoma. Therefore, we constructed a quantitative prognostic model based on the above three significant parameters.
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>Note: </txt>We divided the intrahepatic/extrahepatic metastasis into the following four cases: no (status: 0), solitary intrahepatic metastasis (status: 1), multi-intrahepatic metastasis or portal vein invasion (status: 2), and distant metastasis (status: 3). The tumor capsule was divided into the presence or absence of the tumor capsule.

                                </txt>
                                </div>
                            </Content>
                        </div>

                        <div>
                            <Content style={{ background: '#dcefef' }}>
                                <div style={{ marginLeft: 120, paddingTop:30,paddingRight:60, width: 600, height: 800, background: '#dcefef' }}>
                                
                                <txt style={{fontSize:28,fontWeight:'bold',}}>
                                INSTRUCTIONS
                                </txt>
                        
                                <txt style={{fontSize:20}}>
                                <br/><br/>Click on the <txt style={{fontSize:20,fontWeight:'bold',}}>Calcualtion</txt> button on the left navigation page and slide the input bar, the Calculator will provide the probability of 6-month and 1-year time to progression prediction for TACE therapy. Select the primary tumor size, metastasis, and tumor capsule and the " calculate " button will then generate the analysis. 

                                <br/><br/>In addition, as described in this module, this study also proposed a <txt style={{fontSize:22,fontWeight:'bold'}}>standardized stratification of lipiodol deposition (LD) one month after TACE.</txt> Experiments have shown that one-month postoperative LD is an important factor on the efficacy of TACE. This study has also proposed a refined prognostic model for TACE efficacy prediction: in addition to the above three factors, the one-month postoperative LD was also used as a parameter to predict the efficacy of TACE. The overall prediction can be refined by choosing<txt style={{fontSize:22,fontWeight:'bold'}}> the model which added the parameter of one-month LD after TACE,</txt> in order to make more individualized follow-up strategy in clinical practice. Details in the "Calcualtion" page.
                                </txt>
   
                                </div>
                            </Content>
                        </div>
              </Layout>
            </Content>
            </div>
        )
    }
}
export default HccCalIntro;